import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { PurchaseReport } from '@app/feature/dealer/report/purchase-report';

@Injectable({
  providedIn: 'root'
})
export class ListReportsService {

  constructor(private http: HttpClient) { }


  readReportsList(purchaseDate: string, fisherId: number, dealerId?: number): Observable<PurchaseReport[]> {
    // const purchaseDateParam: string = purchaseDate.getFullYear().toString() + purchaseDate.getMonth().toString() + purchaseDate.getDate().toString();
    const url = `dealers/${dealerId ? dealerId : 'me'}/reports/?purchaseDate=${purchaseDate}&fisherId=${fisherId}`;
    return this.http
      .get(url, {
        headers: { 'Content-Type': 'application/json' }
      })
      .pipe(
        map(response => response ? (response as any[]).map(element => PurchaseReport.fromJSON(element)) : null)
      );
  }

}
